import { styled } from "@mui/material";


const StyledChatInputForm = styled('form')`
  display: flex;
  column-gap: 14px;
  color: #616161;

  .chat-input {


    &__share-location-btn, &__send-text-btn {
      background-color: #fff;
      border-radius: 10px;
      flex-shrink: 0;
      width: 50px;
      height: 50px;
    }

    &__input {
      border-radius: 10px;
      width: 100%;
      border: 0;
      outline: none;
      padding: 16px 24px;
      font-family: "Inter", sans-serif;
      height: auto;


      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.014px;
    }
  }

  @media (max-width: 767.98px) {
    .chat-input {
      &__input {
        font-size: 16px;
      }
    }
  }
`;

export {
  StyledChatInputForm
};
